import React, { useEffect, useLayoutEffect } from 'react';
import './style.css';
import CKEditorCustom from '../CKEditorCustom';
import ImageUploadBase64 from '../ImageUploadBase64';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../redux/actions';
import { dataCrawlState$, postDetailState$ } from '../../redux/selectors';
import { useLocation } from 'react-router-dom';

const initialProduct = {
  title: '',
  currentPrice: 0,
  discountRate: 0,
  oldPrice: 0,
  image: '',
  category: 'product',
  type: '',
  rating: 0,
  reviewCount: 0,
  quantitySold: 'Đã bán 0',
  summary: '',
  author: '',
  likeCount: 0,
  postId: '',
  description: '',
  descriptionTemp: '',
  displayProperty: 'description',
  tikiLink: '',
  shopeeLink: '',
  lazadaLink: '',
  affiliateLink: '',
  backendUrl: '',
};

export default function CreateProduct() {
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [product, setProduct] = React.useState(initialProduct);
  const [initialData, setInitialData] = React.useState('');

  const [productId, setProductId] = React.useState('');
  const [image, setImage] = React.useState('');
  const { state } = useLocation();

  const dispatch = useDispatch();
  const dataCrawl = useSelector(dataCrawlState$);
  const postDetail = useSelector(postDetailState$);

  useLayoutEffect(() => {
    if (state && !!state.id) {
      dispatch(actions.getPostDetail.sendPostDetailRequest({ id: state.id }));
    } else {
      setProduct(initialProduct);
      setInitialData('');
    }
  }, [dispatch, state]);

  useLayoutEffect(() => {
    setInitialData(postDetail.description);
    setProduct(p => ({ ...p, ...postDetail }));
  }, [postDetail]);

  useEffect(() => {
    const { description, ...rest } = dataCrawl;
    setInitialData(description);
    setProduct(p => ({ ...p, ...rest, descriptionTemp: description }));
  }, [dataCrawl]);

  useEffect(() => {
    setProduct(p => ({ ...p, image }));
  }, [image]);

  const handleCrawlData = React.useCallback(() => {
    !!productId && dispatch(actions.crawlData.crawlDataRequest(productId));
  }, [dispatch, productId])

  const handleImageChange = (image) => {
    setImage(image);
  };

  const checkAffiliateRequire = React.useMemo(() => {
    return product.category !== 'application' && ![
      product.tikiLink,
      product.shopeeLink,
      product.lazadaLink,
      product.affiliateLink].some(Boolean);
  }, [product.tikiLink, product.shopeeLink, product.lazadaLink, product.affiliateLink, product.category])

  const handleSubmit = (e) => {
    e.preventDefault();
    if (state && !!state.id) {
      dispatch(actions.updatePost.updatePostRequest(product));
    } else {
      dispatch(actions.createPost.createPostRequest(product));
    }
  };

  return (
    <div style={{ width: '90%', margin: 'auto', fontFamily: 'initial' }}>
      {state && !!state.id
        ? null
        : (
          <div className="row justify-content-center align-items-center crawler-box-shadow">
            <div className="col-lg-auto bg-primary position-relative crawler-wrapper">
              <img
                src="https://salt.tikicdn.com/ts/upload/ae/f5/15/2228f38cf84d1b8451bb49e2c4537081.png"
                alt="Tiki Crawler"
                className=""
                width="60"
                height="40" />
              <span className="position-absolute text-crawler">Tiki Crawler</span>
            </div>
            <div className="col-lg-7 d-flex flex-row">
              <div className="input-group input-group-sm w-75">
                <span className="input-group-text">https://tiki.vn/api/v2/products/</span>
                <input id="productId" type="text" className="form-control"
                  value={productId} onChange={(e) => { setProductId(e.target.value) }} />
              </div>
              <div><button type="button" className="btn btn-sm btn-outline-primary" onClick={handleCrawlData}>Crawl data</button></div>
            </div>
          </div>
        )}
      <form onSubmit={handleSubmit}>
        <div className="row justify-content-start align-items-center pt-3">
          <div className="col-lg-3">
            <ImageUploadBase64 id="image" value={product.image} onChange={handleImageChange} />
          </div>
          <div className="col-lg-8 mx-3">
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-12 mb-3">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">Title</span>
                  <input id="title" type="text" className={`form-control ${!product.title && isSubmitted && 'is-invalid'}`} required
                    value={product.title} onChange={(e) => { setProduct({ ...product, title: e.target.value }) }} />
                </div>
              </div>
              <div className="col-lg-12 mb-3">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-4">
                    <div className="input-group input-group-sm">
                      <span className="input-group-text">Price</span>
                      <input id="currentPrice" type="number" className="form-control"
                        value={product.currentPrice} onChange={(e) => { setProduct({ ...product, currentPrice: e.target.value }) }} />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input-group input-group-sm">
                      <span className="input-group-text">Discount</span>
                      <input id="discountRate" type="number" className="form-control"
                        value={product.discountRate} onChange={(e) => { setProduct({ ...product, discountRate: e.target.value }) }} />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input-group input-group-sm">
                      <span className="input-group-text">Old Price</span>
                      <input id="oldPrice" type="text" className="form-control"
                        value={product.oldPrice} onChange={(e) => { setProduct({ ...product, oldPrice: e.target.value }) }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 mb-3">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-5">
                    <div className="input-group input-group-sm">
                      <span className="input-group-text">Author</span>
                      <input id="author" type="text" className="form-control"
                        value={product.author} onChange={(e) => { console.log('GO'); setProduct({ ...product, author: e.target.value }) }} />
                    </div>
                  </div>
                  <div className="col-lg-7">
                    <div className="input-group input-group-sm">
                      <span className="input-group-text">Product Type</span>
                      <input id="type" type="text" className="form-control"
                        value={product.type} onChange={(e) => { setProduct({ ...product, type: e.target.value }) }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-3">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">Rating</span>
                  <input id="rating" type="number" className="form-control"
                    value={product.rating} onChange={(e) => { setProduct({ ...product, rating: e.target.value }) }} />
                </div>
              </div>
              <div className="col-lg-8 mb-3">
                <div className="d-flex flex-row align-items-center">
                  <div className="input-group-text label-small me-3">Desription Display Property</div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio"
                      value="description" checked={product.displayProperty === 'description'}
                      onChange={(e) => { setProduct({ ...product, displayProperty: e.target.value }) }} />
                    <label className="form-check-label" htmlFor="category">description</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" id="displayProperty"
                      value="descriptionTemp" checked={product.displayProperty === 'descriptionTemp'}
                      onChange={(e) => { setProduct({ ...product, displayProperty: e.target.value }) }} />
                    <label className="form-check-label" htmlFor="category">descriptionTemp</label>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-3">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">Quantity Sold</span>
                  <input id="quantitySold" type="text" className="form-control"
                    value={product.quantitySold} onChange={(e) => { setProduct({ ...product, quantitySold: e.target.value }) }} />
                </div>
              </div>
              <div className="col-lg-8 mb-3">
                <div className="d-flex flex-row align-items-center">
                  <div className="input-group-text label-small me-3">Categories</div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio"
                      value="product" checked={product.category === 'product'}
                      onChange={(e) => { setProduct({ ...product, category: e.target.value }) }} />
                    <label className="form-check-label" htmlFor="category">product</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio"
                      value="application" checked={product.category === 'application'}
                      onChange={(e) => { setProduct({ ...product, category: e.target.value }) }} />
                    <label className="form-check-label" htmlFor="category">application</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio"
                      value="promotion-code" checked={product.category === 'promotion-code'}
                      onChange={(e) => { setProduct({ ...product, category: e.target.value }) }} />
                    <label className="form-check-label" htmlFor="category">promotion-code</label>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 mb-3">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">Backend URL</span>
                  <input id="backendUrl" type="text" className="form-control"
                    value={product.backendUrl} onChange={(e) => { setProduct({ ...product, backendUrl: e.target.value }) }} />
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">Affiliate Link</span>
                  <input id="affiliateLink" type="text"
                    className={`form-control ${product.category !== 'application' && ![product.tikiLink, product.shopeeLink, product.lazadaLink, product.affiliateLink].some(Boolean) && isSubmitted && 'is-invalid'}`}
                    required={checkAffiliateRequire}
                    value={product.affiliateLink}
                    onChange={(e) => { setProduct({ ...product, affiliateLink: e.target.value }) }} />
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">Tiki Link</span>
                  <input id="tikiLink" type="text" className="form-control"
                    value={product.tikiLink} onChange={(e) => { setProduct({ ...product, tikiLink: e.target.value }) }} />
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">Shopee Link</span>
                  <input id="shopeeLink" type="text" className="form-control"
                    value={product.shopeeLink} onChange={(e) => { setProduct({ ...product, shopeeLink: e.target.value }) }} />
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">Lazada Link</span>
                  <input id="lazadaLink" type="text" className="form-control"
                    value={product.lazadaLink} onChange={(e) => { setProduct({ ...product, lazadaLink: e.target.value }) }} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="form-floating">
              <textarea className={`form-control ${!product.summary && isSubmitted && 'is-invalid'}`} id="summary" style={{ height: '80px' }} required
                value={product.summary} onChange={(e) => { setProduct({ ...product, summary: e.target.value }) }}></textarea>
              <label htmlFor="summary">Summary</label>
            </div>
          </div>
        </div>
        <CKEditorCustom initData={initialData} onChange={(description) => { setProduct({ ...product, description }) }} />
        <div className="d-flex flex-row justify-content-center align-items-center mt-3">
          <button type="submit" className="btn btn-outline-primary" onClick={() => { setIsSubmitted(true) }}>
            <b>{state && !!state.id ? 'Update Post' : 'Create Post'}</b>
          </button>
        </div>
      </form>
    </div>
  );
}